export * from './CacheService'
export * from './DataFaker'
export * from './LoadingService'
export * from './Logger'
export * from './utils'
export * from './md5'
export * from './keyparser'

export {
  Memoize
} from 'typescript-memoize'

// To allow regex to be rendered
Object.defineProperty(RegExp.prototype, 'toJSON', {
  value: RegExp.prototype.toString,
})
